import { IRiskOption } from "src/core/constants/options";
import { CustomRiskLevel } from "src/core/constants/risk";
import { Country } from "src/core/gql/graphql";
import { mapRiskCategory } from "src/core/mappers/risk-category.mapper";

export const mapCountriesToRiskOptions = (countries: Country[]): IRiskOption[] => {
  return countries.map((country) => {
    const defaultRisk = country.riskValues.find((risk) => risk.key === "default");
    const risk = defaultRisk ? mapRiskCategory(defaultRisk.riskCategory) : CustomRiskLevel.LOW;

    return {
      id: country.id,
      value: country.code,
      label: country.name,
      risk,
    };
  });
};
